/**
 * Hide PDP Exclusive Offers block.
 * Loaded via ScriptTag so it still runs when Shopify page cache serves stale HTML.
 */
(function hideEffiloPdpOffers() {
  function removeOffers() {
    document.querySelectorAll('.effilo-pdp__offers').forEach(function (el) {
      el.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeOffers);
  } else {
    removeOffers();
  }
})();
